import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "005_procurement_landed_cost",
  version: "1.4.0",
  sql: `
    ALTER TABLE \`inventory_goods_receipt_items\` ADD COLUMN \`purchase_order_id\` text;
    ALTER TABLE \`inventory_goods_receipt_items\` ADD COLUMN \`purchase_order_item_id\` text;
    ALTER TABLE \`inventory_goods_receipt_items\` ADD COLUMN \`landed_cost_amount\` real NOT NULL DEFAULT 0;
    CREATE INDEX IF NOT EXISTS \`gri_po_line_idx\` ON \`inventory_goods_receipt_items\` (\`purchase_order_id\`, \`purchase_order_item_id\`);
  `,
};
